import { defineStore } from 'pinia'
import { ref } from 'vue'

const DEFAULT_MESSAGE = "You don't have permission to perform this action."

export const usePermissionDeniedStore = defineStore('permissionDenied', () => {
  const visible = ref(false)
  const message = ref(DEFAULT_MESSAGE)
  const title = ref('')

  function show(customMessage?: string, customTitle?: string) {
    message.value = customMessage || DEFAULT_MESSAGE
    title.value = customTitle || ''
    visible.value = true
  }

  return { visible, message, title, show }
})
